import { render, staticRenderFns } from "./fccListaPermissoes.vue?vue&type=template&id=4c19253c"
import script from "./fccListaPermissoes.vue?vue&type=script&lang=js"
export * from "./fccListaPermissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports